import { useCallback } from 'react'
import AlbumModel from '../../models/album'
import { API } from '../../services/api'
import { useDebouncedOptions } from '../../utils/useDebouncedOptions'

export const useAlbumAutocomplete = (workspaceId: string) => {
  const search = useCallback(
    async (phrase: string): Promise<Array<AlbumModel>> => {
      if (!workspaceId) return []
      const response = await API.getInstance().getAlbums({ workspaceId, phrase, count: 5 })
      return response.ok && response.data ? response.data : []
    },
    [workspaceId]
  )

  return useDebouncedOptions<AlbumModel>({ search })
}
